/**
 * This helper will log a warning to DataDog with given subject.
 *
 * @param subject {string}  warning message
 * @param data    {*}       optional additional information to be logged
 */
export default (subject, data = null) => {
  if (data) {
    console.warn(`${subject} - Details: `, data);
  } else {
    console.warn(subject);
  }
};
